import React, { Fragment } from "react";

type Props = {
  children: React.ReactNode;
  modalStyle?: string;
  show: boolean;
};

const Modal: React.FC<Props> = ({ children, modalStyle, show }) => {
  return (
    <Fragment>
      {show && (
        <div className="fixed z-10 inset-0 bg-bt-dark-gray-transparent bg-opacity-50 w-full h-full">
          <div className="flex flex-row h-full">
            <div className="relative my-auto mx-auto">
              <div className={modalStyle}>{children}</div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Modal;
